import { Component, OnInit } from '@angular/core';
import { FormsModule, FormBuilder, FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
//import { State } from 'src/app/models/state.model';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";



@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.scss']
})
export class AddVehicleComponent implements OnInit {
  p: number = 1;
  itemsPerPage: number = 10;
  StateRecord: any[] | undefined;
  [x: string]: any;

  addVehicleForm!: FormGroup;
  adduserForm!: FormGroup;
  submitted = false;
  success = false;
  userId: any;
  userRecordData: any[] | undefined;
  testingRecordData!: any[] | undefined;
  manpowerData: any[] | undefined;
  products!: any[];
  parameters: any[];
  selectedProdctName!: any;
  vehicleID: any;
  manpowerID: any;
  districtRecord: any[] | undefined;
  selectedDistrict: any = null;
  distCode:any=null;
  userName: any;

  constructor(private formBuilder: FormBuilder, private router: Router, private fswService: FswService, private authService: AuthService, public sanitizer: DomSanitizer, private toastr: ToastrService, private spinnerService: NgxSpinnerService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {

    this.addVehicleForm = this.formBuilder.group({
      vehicleNo: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(30)]],
      stateCode: ['', Validators.required],
      districtCode: ['', Validators.required],
      userId: [''],
      password: [''],
      roles: [''],
      chasisNo: ['', Validators.required],
      city: [''],
      emailId: ['', [Validators.required, Validators.email]],
      mobileNo: ['', [Validators.required,Validators.minLength(10) ]],
      driverAllocated: ['', Validators.required],
      manpowerAllocated: [''],
      createdBy: ['']
      // mobileNo: ['', [Validators.required, Validators.pattern("^[0-9]{10}$")]]

    })
    // this.stateCode = this.authService.getState();
    this.getState();

    this.route.params.subscribe(params => {

      this.userId = params['userId']; // (+) converts string 'id' to a number
      this.selectedvehicle = this.userId;
    });

    this.userName = this.authService.getUserName();


    if (this.userId) {
      this.distCode=null;
      this.fswService.getUserDetails(this.userId).subscribe((data: any[]) => {
        debugger
        console.log(data);
        var x: any;
        x = data[0];
        console.log(x.chasisNo);
        this.vehicleID = x.id;
        this.selectedState = x.stateCode;
        this.getDistrict();
        this.distCode=x.districtCode;
        //this.selectedDistrict = x.districtCode;
        
        this.addVehicleForm.patchValue({
          vehicleNo: x.vehicleNo,
          stateCode: x.stateCode,
          districtCode: x.districtCode,
          userId: x.userId,
          chasisNo: x.chasisNo,
          city: x.city,
          emailId: x.emailId,
          mobileNo: x.mobileNo,
          driverAllocated: x.driverAllocated,
          manpowerAllocated: x.manpowerAllocated,
          userName: x.userName,
          designation: x.designation,
          createdBy: x.createdBy,
          password: x.password

        });
        //this.spinnerService.hide();
      })
    }
    //For Equipment Tab Start
    this.role = this.authService.getRole();
    this.addEquipmentForm = this.formBuilder.group({
      equipmentType: ['', Validators.required],
      installationDate: ['', Validators.required],
      leastCount: ['', Validators.required],
      model: ['', Validators.required],
      accuracy: ['', Validators.required],
      equipmentId: [''],
      vehicleNo: ['',Validators.required],
      createdBy: ['']
    })
    //For Equipment Tab End
    //For Manpower Tab Start
    this.adduserForm = this.formBuilder.group({
      Id: [''],
      userType: ['', Validators.required],
      name: ['', Validators.required],
      mobile: ['', Validators.required],
      email: ['', Validators.required],
      designation: ['', Validators.required],
      vehicleNo: ['',Validators.required],
      createdBy: ['']
    })
    //this.adduserForm.get('vehicleNo').disable();

    //For Manpower Tab Start
  }
  get f(): { [key: string]: AbstractControl } {
    return this.addVehicleForm.controls;
  }
  get u(): { [key: string]: AbstractControl } {
    return this.adduserForm.controls;
  }
  get e(): { [key: string]: AbstractControl } {
    return this.addEquipmentForm.controls;
  }


  getState() {
    debugger;

    this.spinnerService.show();
    this.fswService.getState().subscribe(
      (Statedata) => {
        this.StateRecord = Statedata;
        if (this.stateCode) {
          this.selectedState = this.stateCode;
        }
        this.spinnerService.hide();
      }
    )
  }

  getDistrict() {
    debugger

    var stateCode = '';
    // stateCode = this.authService.getState();
    this.fswService.getDistrict(this.selectedState).subscribe((Districtdata) => {
      this.districtRecord = Districtdata;
      if (this.selectedDistrict == undefined) {
        this.selectedDistrict = "";
      }
      else
      {
            this.selectedDistrict=this.distCode;
      }
    })
  }



  onaddVehicleSubmit() {

    this.submitted = true;
    this.spinnerService.show();
    if (this.addVehicleForm.invalid) {
      return;
    }
    var role = ["ROLE_USER"]
    var vehicleNo = this.addVehicleForm.get('vehicleNo')?.value;
    var password = this.addVehicleForm.get('password')?.value;
    const replacedvehicleNo = vehicleNo.replaceAll('-', '')
    this.addVehicleForm.controls['password'].setValue(password);
    this.addVehicleForm.controls['userId'].setValue(replacedvehicleNo);
    this.addVehicleForm.controls['vehicleNo'].setValue(vehicleNo);
    this.addVehicleForm.controls['roles'].setValue(role);
    this.addVehicleForm.controls['createdBy'].setValue(this.userName)

    if (this.vehicleID) {
      this.fswService.updateProfileData(this.vehicleID, this.addVehicleForm.value)
        .subscribe(
          response => {
            this.submitted = false;
            this.toastr.success('Vehicle Data Updated Successfully!');
            this.spinnerService.hide();
            this.userId = response.userId;
            this.clickTab(2);
          },
          error => {
            console.log(error);
            this.toastr.error('Error Occured!');
            this.spinnerService.hide();

          });
    }
    else {
      debugger;
      console.log(this.addVehicleForm.value);
      this.fswService.addVehicle(this.addVehicleForm.value)
        .subscribe(
          response => {
            this.submitted = false;
            //this.addVehicleForm.reset({});
            this.spinnerService.hide();
            this.toastr.success('Vehicle Added Successfully!');
            //this.router.navigateByUrl("fsw/list-vehicle");
            console.log(response);
            this.userId = response.userId;
            this.vehicleID = response.id;
            this.addVehicleForm.reset({});
            this.clickTab(2);
          },
          error => {
            debugger
            console.log(error);
            this.toastr.error('Error Occured!');
            this.spinnerService.hide();
          });
    }
    //this.success = true;

  }
  closeAlert() {
    this.success = false;
  }
  selectedState: any = null;
  //for tab start
  tab: number = 1;
  clickTab(tabNo) {
    //this.userId = "DL32AJ2332";
    if (!this.userId) {
      this.toastr.error('First Fill Basic Detail!');
      return;
    }
    this.tab = tabNo;
    if (tabNo == 3) {

      this.selectedequipmentsCapabilities = null;
      this.isReadModeEquipmentList = true;
      this.isWriteModeEquipmentList = false;
      this.bindequipmentlist(this.userId);
    }
    else if (tabNo == 4) {
      this.isReadModeTestingCapability = true;
      this.isWriteModeTestingCapability = false;
      this.bindtestingcapabilitylist(this.userId);
    }
    else if (tabNo == 2) {
      this.isReadModeManpower = true;
      this.isWriteModeManpower = false;
      this.bindmanpowerlist(this.userId);
    }
    else if (tabNo == 1) {
      if (this.userId) {
        this.fswService.getUserDetails(this.userId).subscribe((data: any[]) => {
          debugger
          console.log(data);
          var x: any;
          x = data[0];
          console.log(x.chasisNo);
          this.vehicleID = x.id;
          this.selectedState = x.stateCode;
          this.addVehicleForm.patchValue({
            vehicleNo: x.vehicleNo,
            stateCode: x.stateCode,
            userId: x.userId,
            chasisNo: x.chasisNo,
            city: x.city,
            emailId: x.emailId,
            mobileNo: x.mobileNo,
            driverAllocated: x.driverAllocated,
            manpowerAllocated: x.manpowerAllocated,
            userName: x.userName,
            designation: x.designation,
            createdBy: x.createdBy
          });
          this.spinnerService.hide();
        })
      }

    }
  }
  //for tab end

  //For Equipment tab Start
  isReadModeEquipmentList = true;
  isWriteModeEquipmentList = false;
  getEquipmentForAll() {
    this.spinnerService.show();
    this.fswService.getEquipmentDDAll()
      .subscribe(res => {

        this.equipmentsData = res;
        this.spinnerService.hide();
      });
  }
  bindequipmentlist(userId) {

    this.spinnerService.show();
    this.fswService.getequipmentlist(userId).subscribe((data: any[]) => {
      this.equipRecordData = data;
      this.spinnerService.hide();
    })

  }
  createEquipment() {

    this.isReadModeEquipmentList = false;
    this.isWriteModeEquipmentList = true;
    this.getEquipmentForAll();
    this.getUserData();
  }
  getUserData() {
    this.spinnerService.show();
    this.fswService.getVehicleListByState(this.authService.getState()).subscribe((data: any[]) => {
      console.log(data);
      this.userRecordData = data;
      this.selectedvehicle = this.userId;
      this.spinnerService.hide();
    })
  }
  backEquipmentList() {
    this.isReadModeEquipmentList = true;
    this.isWriteModeEquipmentList = false;
    this.bindequipmentlist(this.userId);
  }
  saveEquipmentData() {

    this.spinnerService.show();
    this.submitted = true;

    if (this.addEquipmentForm.invalid) {
      return;
    }
    this.addEquipmentForm.controls['createdBy'].setValue(this.userName);
    console.log(this.addEquipmentForm.value);
    this.fswService.saveFSWEquipment(this.addEquipmentForm.value)
      .subscribe(
        response => {

          this.submitted = false;
          this.spinnerService.hide();
          this.addEquipmentForm.reset({});
          this.isReadModeEquipmentList = true;
          this.isWriteModeEquipmentList = false;
          this.toastr.success('Equipment Data Saved Successfully!');
          this.bindequipmentlist(this.userId);
        },
        error => {

          console.log(error);
          this.toastr.error('Some Error Occured!');
          this.spinnerService.hide();
        });

  }
  deleteEquip(x: any) {
    debugger
    var delBtn = confirm(" Do you want to delete ?");
    if (delBtn == true) {
      this.spinnerService.show();
      this.fswService.deleteEquipmentId(x.Id)
        .subscribe(res => {
          debugger
          this.bindequipmentlist(this.userId);
          this.toastr.success('Equipment Data Deleted Successfully!');
          this.spinnerService.hide();
        },
          error => {

            console.log(error);
            this.toastr.error('Some Error Occured!');
            this.spinnerService.hide();
          });
    }
  }
  //For Equipment tab End
  //For Testing Capability tab Start
  isReadModeTestingCapability = true;
  isWriteModeTestingCapability = false;
  bindtestingcapabilitylist(userId) {

    this.spinnerService.show();
    this.fswService.gettestingcapabilitylist(userId).subscribe((data: any[]) => {
      this.testingRecordData = data;
      this.spinnerService.hide();
    })
  }
  createTestingCapability() {
    this.isReadModeTestingCapability = false;
    this.isWriteModeTestingCapability = true;
    this.bindProduct();
    this.getUserData();
  }
  bindProduct() {
    this.spinnerService.show();
    this.fswService.getProducts().subscribe((data: any[]) => {
      this.products = data;
      this.spinnerService.hide();
    })

  }
  productChanged() {
    this.products = [];
    this.bindParameter()


  }
  bindParameter() {
    this.spinnerService.show();
    this.fswService.getFSWParameters(this.selectedvehicle, this.selectedproductId).subscribe((data: any[]) => {
      this.parameters = data;
      this.selectedProdctName = data[0].productName;
      this.spinnerService.hide();
    })

  }
  backTestingCapabilityList() {
    this.isReadModeTestingCapability = true;
    this.isWriteModeTestingCapability = false;
    this.bindtestingcapabilitylist(this.userId);
  }
  saveTestingCapabilityData() {
    ;
    this.nonresult = false;
    this.submitted = true;
    var sampleId = 0;
    let testingData: any = [];
    this.parameters.forEach(item => {
      testingData.push({ id: item.Id, mappingId: item.mappingId, vehicleNo: this.selectedvehicle, createdBy: this.authService.getUserName(), result: item.result })
    })
    this.fswService.saveFSWTestCapability(testingData)
      .subscribe(
        resp => {

          console.log(resp)
          this.submitted = true;
          this.spinnerService.hide();
          this.toastr.success('Test Capability Added Successfully!');
          this.bindProduct();
          this.bindParameter()
          this.isReadModeTestingCapability = true;
          this.isWriteModeTestingCapability = false;
        },
        error => {

          console.log(error);
          this.toastr.error('Some Error Occured!');
          this.spinnerService.hide();
        });
  }
  updateTestingCapabilityData(x: any) {

    var delBtn = confirm(" Do you want to update?");
    if (delBtn == true) {

      if (x) {
        this.spinnerService.show();
        this.isReadMode = false;
        this.spinnerService.hide();
      }
      else {
        this.isReadMode = false;
      }
    }
  }
  //For Testing Capability tab Start
  //For Manpower tab Start
  isReadModeManpower = true;
  isWriteModeManpower = false;

  bindmanpowerlist(userId) {

    this.spinnerService.show();
    this.fswService.getFSWManpowerlist(userId).subscribe((data: any[]) => {
      this.manpowerData = data;
      this.spinnerService.hide();
    })
  }
  createManpower() {

    this.isReadModeManpower = false;
    this.isWriteModeManpower = true;
    this.adduserForm.reset({});
    this.manpowerID = null;
    this.getUserData();
    //this.selectedvehicle = this.userId;
  }
  saveManpowerData() {
    debugger
    this.spinnerService.show();
    this.submitted = true;

    if (this.adduserForm.invalid) {
      return;
    }
    this.adduserForm.controls['createdBy'].setValue(this.userName);
    // var role = ["ROLE_SO"]
    // this.adduserForm.controls['roles'].setValue(role);
    console.log(this.adduserForm.value);
    this.fswService.saveFSWManpower(this.adduserForm.value)
      .subscribe(
        response => {
          this.submitted = false;
          this.spinnerService.hide();
          this.isReadModeManpower = true;
          this.isWriteModeManpower = false;
          this.bindmanpowerlist(this.userId)
          this.seachText = null;
          this.adduserForm.reset({});
          this.toastr.success('Manpower Data Saved Successfully!');
        },
        error => {
          console.log(error);
          this.spinnerService.hide();
          this.toastr.error('Error Occured!');
        });

    this.success = true;
    this.adduserForm.reset({});
  }
  updateManpower(x: any) {

    var delBtn = confirm(" Do you want to update ?");
    if (delBtn == true) {

      if (x) {
        debugger
        this.getUserData();
        this.spinnerService.show();
        this.isReadModeManpower = false;
        this.isWriteModeManpower = true;
        this.manpowerID = x.id;
        this.selectedvehicle = x.vehicleNo;
        this.adduserForm.controls['id'].setValue(x.id);
        this.adduserForm.controls['vehicleNo'].setValue(x.vehicleNo);
        this.adduserForm.controls['userType'].setValue(x.userType);
        this.adduserForm.controls['name'].setValue(x.name);
        this.adduserForm.controls['mobile'].setValue(x.mobile);
        this.adduserForm.controls['email'].setValue(x.email);
        this.adduserForm.controls['designation'].setValue(x.designation);
        this.adduserForm.controls['createdBy'].setValue(this.userName)
        this.spinnerService.hide();
      }
      else {
        this.isReadModeManpower = true;
        this.isWriteModeManpower = false;
      }
    }
  }
  backManpowerList() {
    this.isReadModeManpower = true;
    this.isWriteModeManpower = false;
    this.bindmanpowerlist(this.userId);
  }
  //For Manpower tab End

}


